import { CLEAR_OBJECT_HAS_NEW_COMMENTS } from "~/store/action_types";

export const clearObjectHasNewComments = (objectType, id) => {
  return {
    type: CLEAR_OBJECT_HAS_NEW_COMMENTS,
    objectType,
    id,
  };
};
